<template>
  <v-container
    id="DocumentList"
  >
    <v-card>
      <v-card-title>
        {{ title }}
        <v-spacer />
        <v-btn color="primary" @click="uploadFile">
{{ $t('add-file') }}
</v-btn>
      </v-card-title>
      <v-card-text>
        <div class="searchBox">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('global.search')"
            :aria-label="$t('global.text-field')+' '+$t('global.search') +' '+ $t('documents.documents')"
            single-line
            hide-details
          />
        </div>
         <v-data-table
          filterable
          :headers="computedHeaders.map((x) => { return { ...x, text: $t(x.text) } })"
          :items="items"
          item-key="id"
          :loading="loading"
          :search="search"
          :items-per-page="rowsPerPage"
        >
        <template v-slot:item.name="{ item }">
            <a target="_blank" :href="item.url">
              {{ item.name }}
            </a>
          </template>
          <template v-slot:item.type="{ item }">
              {{ item.type }}
          </template>
          <template v-slot:item.created="{ item }">
              {{ displayTime(item.created) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon v-if="item.id !== $store.getters.currentUserProfile.user.id" 
                  class="mr-2" 
                  :aria-label="$t('global.delete') + ' ' + $t('documents.documentParam', [item.name])"
                  v-on="on" 
                  @click="deleteItem(item)"
                >
                mdi-delete-outline
                </v-icon>
              </template>
              <span>{{ $t('delete') }}</span>
            </v-tooltip>
          </template>
          </v-data-table>
      </v-card-text>
    </v-card>
    <v-row justify="center">
    <v-dialog v-model="showDeleteDialog" max-width="500px">
      <v-card>
          <v-card-text>
           <h3 class="text-center text-white pt-10">
{{ $t('users.confirm-delete', [editedItem.name]) }}
</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
              <v-btn @click="closeDeleteDialog">
{{ $t('global.cancel') }}
</v-btn>
              <v-btn color="red" @click="confirmDeleteItem">
{{ $t('global.confirm') }}
</v-btn>
              <v-spacer />
               <v-overlay :value="busy">
                  <v-progress-circular
                    indeterminate
                    size="64"
                  />
                </v-overlay>
            </v-card-actions>
          </v-card>
    </v-dialog>
    <v-card-actions>
    <v-dialog v-model="showUploadModal" persistent max-width="600px">
        <upload-document ref="uploadDocumentComponent" :exceeded-max-file-uploaded="exceededMaxFileUploaded" :items="items" @uploadedFileToSave="uploadedFile" @save="saveFile" @closeModal="closeModal" />
         <v-overlay :value="uploadProgress">
                  <v-progress-circular
                    indeterminate
                    size="64"
                  />
            </v-overlay>
      </v-dialog>
    </v-card-actions>
    </v-row>
</v-container>
</template>

<script>
  import 'firebase/auth'
  import api from '@/helpers/api.js'
  import UploadDocument from './UploadDocument.vue'
  import moment from 'moment'
  export default {
    name: 'Document',
    components: {
      'upload-document': UploadDocument,
    },
    props: {
      title: { type: String, required: false, default: 'Documents' },
    },
    data () {
      return {
        loading: false,
        busy: false,
        showDeleteDialog: false,
        uploadProgress: false,
        editedItem: {},
        showUploadModal: false,
        exceededMaxFileUploaded: false,
        headers: [
          { text: 'documents.headers.name', sortable: true, value: 'name' },
          { text: 'documents.headers.type', sortable: true, value: 'type' },
          { text: 'documents.headers.upload-date', sortable: true, value: 'created' },
          { text: 'documents.headers.actions', value: 'actions', sortable: false },
        ],
        items: [],
        uploadDocument: { },
        search: '',
        rowsPerPage: 10,
      }
    },
    computed: {
      computedHeaders () {
        return this.headers.filter(x => { return this.role === undefined || x.value !== 'role' })
      },
    },
    async mounted () {
      this.loading = true
      await this.refreshItems()
    },
    methods: {
      uploadFile () {
        this.checkUserUploadedFiles()
        this.showUploadModal = true
      },
      createUrl (item) {
        return item.url
      },
      displayTime (time) {
        return this.$i18n.d(moment(time), 'long')
      },
      uploadedFile (file) {
        this.uploadDocument = file
      },
      async saveFile () {
        this.uploadProgress = true
        try {
          await api.uploadDocument(this.uploadDocument)
          await this.refreshItems()
          this.showUploadModal = false
        } catch (e) {
          console.log({ e })
          let errorMessage = 'An error occurred while uploading the document.'
          if (e.response && e.response.status === 400) {
            errorMessage = e.response.data || 'Bad request: Invalid file or parameters.'
          }
          if (this.$refs.uploadDocumentComponent) {
            this.$refs.uploadDocumentComponent.setUploadError(errorMessage)
          }
        }
        this.uploadProgress = false
      },
      checkUserUploadedFiles () {
        if (this.items.length >= 10) {
          this.exceededMaxFileUploaded = true
        } else {
          this.exceededMaxFileUploaded = false
        }
      },
      closeModal (closeModal) {
        this.showUploadModal = closeModal
      },
      deleteItem (itemToDelete) {
        this.editedItem = itemToDelete
        this.showDeleteDialog = true
      },
      async getDocuments () {
        const documents = await api.getDocuments()
        this.items = documents
      },
      closeDeleteDialog () {
        this.showDeleteDialog = false
      },
      async confirmDeleteItem () {
        this.busy = true
        await api.deleteDocuments(this.editedItem.id)
        this.closeDeleteDialog()
        this.items = this.items.filter(item => item.id !== this.editedItem.id)
        this.busy = false
      },
      async refreshItems () {
        this.loading = true
        const documents = await api.getDocuments()
        this.items = documents === null ? [] : documents
        this.loading = false
      },
    },
  }
</script>

